var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.loadingTeams)?_c('TableSkeletonLoader'):_c('TeamsTable',{attrs:{"teams":_vm.allTeams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }